<template>
  <div class="page fs16">
    <div class="banner" style="font-size:28px;line-height:46px;background-color:#00225d;">
      <div
        class="banner-img"
        style="background-image:url(https://static.wkanx.com/w002/M00/05/B2/CgIXlV6EFkmAThf6AAEjc4nZloI924.jpg)"
      ></div>
      <div class="abs-center-h">
        <div v-parallax="0.35">
          <div>多种类型广告驱动</div>
          <div>精准触达目标用户</div>
        </div>
      </div>
    </div>
    <div class="p-v-8 tc">
      <div class="fs18 fwb m-b-3">信息流banner</div>
      <div class="">在WiFi万能钥匙信息流中，穿插展示的原生广告</div>
      <div class=" m-b-8">根据用户兴趣推荐，更加自然高效</div>
      <div flex="main:center cross:bottom" class="container m-v-4">
        <div class="m-r-3">
          <div
            v-parallax="0.05"
            class="bg-cover"
            style="width:203px;height:450px;background-image:url(/imgs/introduction_banner_1.png)"
          ></div>
          <div class="rel bg-white oh" style="box-shadow: rgb(255, 255, 255) 0px -10px 25px 25px">竖版</div>
        </div>
        <div class="m-r-3">
          <div
            v-parallax="0.03"
            class="bg-cover"
            style="width:240px;height:500px;background-image:url(/imgs/introduction_banner_2.png)"
          ></div>
          <div class="rel bg-white oh" style="box-shadow: rgb(255, 255, 255) 0px -10px 25px 25px">横版</div>
        </div>
        <!-- <div>
          <div
            v-parallax="0.07"
            class="bg-cover"
            style="width:121px;height:200px;background-image:url(https://static.wkanx.com/w002/M00/05/B2/CgIXGF6EGn2AEqMAAAB5SVhFXiI109.png)"
          ></div>
          <div class="rel bg-white oh" style="box-shadow: rgb(255, 255, 255) 0px -10px 25px 25px">底部全屏</div>
        </div> -->
      </div>
    </div>
    <div class="p-v-8 tc bg-blue">
      <div class="fs18 fwb m-b-3">全屏广告</div>
      <div class="">在WiFi万能钥匙中，以开屏、插屏、连接加速页全屏等强曝光的广告形式</div>
      <div class="">视觉冲击强烈，直取广告痛点</div>
      <div flex="main:center cross:bottom" class="container m-t-8 m-b-4">
        <div v-parallax="0.04">
          <div
            class="bg-cover"
            style="width:200px;height:422px;background-image:url(/imgs/introduction_full_1.png);margin-bottom: 15px;"
          ></div>
          <div>开屏</div>
        </div>
        <div style="margin:0 0 0 -8px;" class="rel" v-parallax="0.03">
          <div
            class="bg-cover"
            style="width:230px;height:485px;background-image:url(/imgs/introduction_full_2.png);margin-bottom: 15px;"
          ></div>
          <div>插屏</div>
        </div>
        <div style="margin:0 0 0 -5px;" v-parallax="0.05">
          <div
            class="bg-cover"
            style="width:200px;height:422px;background-image:url(/imgs/introduction_full_3.png);margin-bottom: 15px;"
          ></div>
          <div>连接页全屏</div>
        </div>
      </div>
    </div>
    <div class="bg-gray p-v-8 tc m-b-7 oh">
      <div v-parallax="0.1">
        <div class="fs18 fwb m-b-4 m-t-8">视频广告</div>
        <div class="">在WiFi万能钥匙中黄金位置，内容原生，基于兴趣精准推荐</div>
        <div class="">沉浸式浏览，提升用户关注时长，高效引流</div>
        <div flex="main:center cross:bottom" class="container m-t-8 m-b-4">
          <div>
            <div
              class="bg-cover"
              style="width:240px;height:485px;background-image:url(/imgs/introduction_video_1.png);margin-bottom: 15px;"
            ></div>
            <div>激励视频</div>
          </div>
          <div class="rel" style="margin-left: 25px;">
            <div
              class="bg-cover"
              style="width:240px;height:485px;background-image:url(/imgs/introduction_video_2.png);margin-bottom: 15px;"
            ></div>
            <div>短剧中插</div>
          </div>
        </div>
        <!-- <img
          class="m-t-5"
          src="https://static.wkanx.com/w002/M00/05/B2/CgIXGF6EHvWAGGF5AAD8QTZ44kM081.png"
          width="560"
          alt=""
        /> -->
        <!-- <div class="m-b-8 m-t-4">下载类广告：可点击底部“立即下载”按钮下载广告对应的APP应用</div>
        <img src="https://static.wkanx.com/w002/M00/05/B3/CgIXgV6EH0GAbZ0_AAESjay8QWc276.png" width="360" alt="" />
        <div class="m-t-3 m-b-4">跳转类广告：可点击底部“查看详情”按钮跳转至广告落地页</div> -->
      </div>
      <div style="height: 40px;"></div>
    </div>
    <div style="height: 40px;"></div>
  </div>
</template>
<script>
export default {
  name: '',
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped></style>
